import { rest } from 'msw';
import { mockProducts } from 'test-utils/mock-data/products';
import { parseApiProduct } from 'api-services/product-requests';
import { v4 as uuidv4 } from 'uuid';

const backendUrl = process.env.BACKEND_API_URL || '';

export const productHandlers = [
  rest.get(`${backendUrl}/products`, (req, res, ctx) => {
    const visible = req.url.searchParams.get('visible');
    return res(
      ctx.status(200),
      ctx.json(visible
        ? mockProducts.filter(product => product.visible.toString() === visible)
        : mockProducts),
    );
  }),
  rest.get(`${backendUrl}/product/:id`, (req, res, ctx) => {
    const { id } = req.params;
    const product = mockProducts.find(product => product.id === id);
    if (!product) return res(ctx.status(400));
    return res(
      ctx.status(200),
      ctx.json(product),
    );
  }),
  rest.post(`${backendUrl}/product`, (req, res, ctx) => {
    const product = { ...parseApiProduct(req.body), id: uuidv4() };
    mockProducts.push(product);
    return res(
      ctx.status(200),
      ctx.json(product),
    );
  }),
  rest.put(`${backendUrl}/product`, (req, res, ctx) => {
    const modifications = parseApiProduct(req.body);
    const existingIndex = mockProducts.findIndex(product => product.id === modifications.id);
    if (existingIndex === -1) {
      if (!('image' in modifications)) return res(ctx.status(400), ctx.text('PUT failed: no image in new product'));
      mockProducts.push({ ...modifications, id: uuidv4() });
    } else {
      mockProducts[existingIndex] = { ...mockProducts[existingIndex], ...modifications };
    }
    return res(
      ctx.status(200),
      ctx.json(mockProducts[existingIndex === -1 ? mockProducts.length - 1 : existingIndex]),
    );
  }),
  rest.delete(`${backendUrl}/product/:id`, (req, res, ctx) => {
    const { id } = req.params;
    const productIndex = mockProducts.findIndex(product => product.id === id);
    if (productIndex === -1) return res(ctx.status(400));
    const product = mockProducts[productIndex];
    mockProducts.splice(productIndex, 1);

    return res(
      ctx.status(200),
      ctx.json(product),
    );
  }),
];
